import { ItemKind } from '../../../constants/ItemKind';
import { encodeItemId } from '../parsers/item-id';
export const oldMediaManagerFolder = {
  id: encodeItemId(null, null),
  kind: ItemKind.Folder,
  source: 'wixSite',
  parentId: 'wix-sites',
  name: 'All My Files',
  createdAt: 0,
  updatedAt: 0,
  siteId: null,
  userId: null,
  tags: ['_all-my-files-folder']
};